import { DeliveryMode, KsdkEventData } from '@kollective-frontend/ksdk-api';
import { dispatchInfo } from '../events/dispatch';

export const enum CONNECTION_INFO_EVENT_TAGS {
  FAILURE = 'failure',
  NOT_ENABLED = 'not_enabled',
  NO_PLAYBACK_METHOD = 'no_playback_method'
}

export const INFO_MESSAGE_MAP = {
  bbp_agent_failure: 'Failed to start a browser agent connection',
  bbp_agent_not_enabled: 'Browser Agent not enabled',
  bbp_agent_no_playback_method: 'Browser Agent not in playback list',
  bbp_agent_tag: 'WebRTC',
  eleven_agent_failure: 'Failed to start an 11 installed agent connection',
  eleven_agent_tag: 'LocalAgent',
  eleven_agent_not_enabled: 'Installed Agent not enabled',
  eleven_agent_no_playback_method: 'Installed Agent not in playback list'
};

const dispatchConnectionInfo = (
  type: DeliveryMode.WEBRTC | DeliveryMode.ECDN11,
  key: CONNECTION_INFO_EVENT_TAGS,
  error?: unknown
): void => {
  const reason = INFO_MESSAGE_MAP[`${type}_${key}`];
  const information = INFO_MESSAGE_MAP[`${type}_tag`];
  const event: KsdkEventData = { information, reason };
  const e = error as Error;
  if (e) {
    event.messages = [`Error: ${e.name}: ${e.message}`];
  }
  dispatchInfo(event);
};
export default dispatchConnectionInfo;
